import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import './QuemSomos.css';

const QuemSomos = () => {
  const navigate = useNavigate();

  const handleCTAClick = () => {
    navigate('/registro');
  };

  return (
    <div className="quem-somos-page">
      <Header />

      <main className="main-content">
        {/* Hero Section */}
        <section className="hero-section quem-somos-hero">
          <div className="hero-background">
            <div className="container">
              <div className="hero-content">
                <div className="hero-badge">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2L2 7v10c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-10-5z"/>
                  </svg>
                  Desde 2015
                </div>

                <h1 className="hero-title">
                  Transformando o Mercado de<br />
                  <span className="highlight-text">Precatórios</span> com Tecnologia
                </h1>

                <p className="hero-subtitle">
                  A MICA Capital é líder em soluções tecnológicas para o mercado de precatórios, combinando anos de experiência com Inteligência Artificial de ponta.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Mission Section */}
        <section className="mission-section">
          <div className="container">
            <div className="mission-grid">
              <div className="mission-card">
                <div className="mission-icon">
                  <svg width="60" height="60" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2L2 7v10c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-10-5zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V7.89l7-3.11v8.2z"/>
                  </svg>
                </div>
                <h3>Nossa Missão</h3>
                <p>Democratizar o acesso ao mercado de precatórios através da tecnologia, oferecendo soluções rápidas, transparentes e seguras para todos.</p>
              </div>

              <div className="mission-card mission-card-highlight">
                <div className="mission-icon">
                  <svg width="60" height="60" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                  </svg>
                </div>
                <h3>Nossa Visão</h3>
                <p>Ser a plataforma de referência em tecnologia para precatórios na América Latina, revolucionando o mercado com inovação contínua.</p>
              </div>

              <div className="mission-card">
                <div className="mission-icon">
                  <svg width="60" height="60" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>
                  </svg>
                </div>
                <h3>Nossos Valores</h3>
                <p>Transparência, inovação, segurança jurídica e compromisso com resultados excepcionais para nossos clientes.</p>
              </div>
            </div>
          </div>
        </section>

        {/* History Section */}
        <section className="history-section">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">Nossa História</h2>
              <div className="title-divider"></div>
            </div>

            <div className="history-content">
              <div className="history-text">
                <p className="lead-text">
                  Fundada em 2015, a MICA Capital nasceu da visão de transformar o complexo mercado de precatórios em algo simples, rápido e acessível.
                </p>
                <p>
                  Com mais de 10 anos de experiência no mercado financeiro e jurídico, nossa equipe identificou uma grande oportunidade: usar tecnologia de ponta para resolver problemas históricos do setor de precatórios.
                </p>
                <p>
                  Investimos pesadamente em Inteligência Artificial e automação, desenvolvendo uma plataforma única que analisa, valida e processa precatórios em tempo recorde, reduzindo de meses para dias o tempo necessário para fechar negócios.
                </p>
                <p>
                  Hoje, somos referência em tecnologia para precatórios, atendendo centenas de clientes e processando milhões em ativos judiciais com total segurança e transparência.
                </p>
              </div>

              <div className="history-stats">
                <div className="stat-item">
                  <div className="stat-number">10+</div>
                  <div className="stat-label">Anos de Experiência</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">500+</div>
                  <div className="stat-label">Clientes Atendidos</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">R$ 200M+</div>
                  <div className="stat-label">Em Transações</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">27</div>
                  <div className="stat-label">Estados Cobertos</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Differentials Section */}
        <section className="differentials-section">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title white-title">O Que Nos Diferencia</h2>
            </div>

            <div className="differentials-grid">
              <div className="differential-card">
                <div className="differential-icon">
                  <svg width="50" height="50" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20 3H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h3l-1 1v2h12v-2l-1-1h3c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H4V5h16v11z"/>
                  </svg>
                </div>
                <h3>Tecnologia de IA</h3>
                <p>Inteligência Artificial própria que analisa e processa precatórios com precisão incomparável.</p>
              </div>

              <div className="differential-card">
                <div className="differential-icon">
                  <svg width="50" height="50" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
                  </svg>
                </div>
                <h3>Velocidade Incomparável</h3>
                <p>Do cadastro ao pagamento em até 5 dias, quando o mercado leva meses.</p>
              </div>

              <div className="differential-card">
                <div className="differential-icon">
                  <svg width="50" height="50" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>
                  </svg>
                </div>
                <h3>Segurança Total</h3>
                <p>Processos validados juridicamente e total transparência em todas as operações.</p>
              </div>

              <div className="differential-card">
                <div className="differential-icon">
                  <svg width="50" height="50" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
                  </svg>
                </div>
                <h3>Equipe Especializada</h3>
                <p>Profissionais experientes nas áreas jurídica, financeira e tecnológica.</p>
              </div>

              <div className="differential-card">
                <div className="differential-icon">
                  <svg width="50" height="50" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"/>
                  </svg>
                </div>
                <h3>Dados em Tempo Real</h3>
                <p>Acompanhamento completo de todas as etapas através de dashboard intuitivo.</p>
              </div>

              <div className="differential-card">
                <div className="differential-icon">
                  <svg width="50" height="50" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                  </svg>
                </div>
                <h3>Abrangência Nacional</h3>
                <p>Atuação em todos os 27 estados brasileiros com cobertura completa.</p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta-section">
          <div className="container">
            <div className="cta-content">
              <h2 className="cta-title">Faça Parte da Revolução dos Precatórios</h2>
              <p className="cta-subtitle">
                Junte-se a centenas de clientes que já confiam na MICA Capital para suas negociações de precatórios.
              </p>
              <button className="btn btn-primary btn-large" onClick={handleCTAClick}>
                Cadastrar Meu Precatório
              </button>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default QuemSomos;
